import * as z from "zod";
import { ItemSummary } from "./item";

/** A sealed product a shop sells to anyone, carted by quantity without a scan. */
export const PublicOffer = z.object({
  id: z.string(),
  storeId: z.string(),
  /** Per unit, in minor units. */
  priceCents: z.number(),
  currencyCode: z.string(),
  /** Units free to cart right now. */
  available: z.number(),
  item: ItemSummary,
  sealed: z
    .object({
      setName: z.string(),
      productType: z.string(),
      configuration: z.string().nullable(),
      language: z.string().nullable(),
    })
    .nullable(),
});
export type PublicOffer = z.output<typeof PublicOffer>;

/** A wanted quantity kept between one and what is free; zero when nothing is. */
export function clampQuantity(wanted: number, available: number): number {
  if (available <= 0) return 0;
  return Math.min(Math.max(1, Math.floor(wanted)), available);
}
